import { RunContextApp } from 'framework/RCApp';
import { createCxApiClient as createReal } from '../../apis/cxEditorAPI';

// No mock client - use real API for all endpoints
export function createCxApiClient(rc: RunContextApp, baseUrl: string) {
  const realClient = createReal(rc, baseUrl);
  
  // Use real API for all endpoints
  return {
    getTemplates: realClient.getTemplates.bind(realClient),
    getTemplateMeta: realClient.getTemplateMeta.bind(realClient),
    getScenarios: realClient.getScenarios.bind(realClient),
    getInspector: realClient.getInspector.bind(realClient),
    getInspectorConfigs: realClient.getInspectorConfigs.bind(realClient),
    renderHTML: realClient.renderHTML.bind(realClient),
    renderDynamic: realClient.renderDynamic.bind(realClient),
    saveChanges: realClient.saveChanges.bind(realClient),
    save: realClient.save.bind(realClient),
    toggleOverride: realClient.toggleOverride.bind(realClient),
    signoff: realClient.signoff.bind(realClient),
    getPalette: realClient.getPalette.bind(realClient),
    getDataScenarios: realClient.getDataScenarios.bind(realClient),
    saveStrings: realClient.saveStrings.bind(realClient),
    getEditedConfigsForSection: realClient.getEditedConfigsForSection.bind(realClient),
    completeExportAudit: realClient.completeExportAudit.bind(realClient),
    getFeatureMetrics: realClient.getFeatureMetrics.bind(realClient),
    getBulkManage: realClient.getBulkManage.bind(realClient),
    fetchHerPreviewHtml: realClient.fetchHerPreviewHtml.bind(realClient),
    proxyImage: realClient.proxyImage.bind(realClient),
    getDataScenarioDetails: realClient.getDataScenarioDetails.bind(realClient),
  } as any;
}





